<template>
  <AppLink
    to="/"
    class="logo"
  >
    <img
      :src="logo"
      alt=""
      class="logo__image"
      width="331"
      height="61"
    >
  </AppLink>
</template>

<script setup lang="ts">
const logo = '/bagageonline.svg'
</script>

<style>
@import url("~layers/app/components/App/Logo.css");
</style>
